import React from "react";
import { Button, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

class ScriptsTabActionCell extends React.PureComponent {
  render() {
    return (
      <Row style={{ display: "block" }}>
        <div className="floatRight">
          <Button
            className="btn-red"
            onClick={event => {
              event.stopPropagation();
              this.props.onRemove();
            }}
          >
            <FontAwesomeIcon icon={faTimes} size="1x" />
          </Button>
        </div>
      </Row>
    );
  }
}

export default ScriptsTabActionCell;
